import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EditProfileForm from "./EditProfileForm";
import axiosInstance from "../../../services/AxiosInstance";
import { values } from "lodash";
import { actions } from "react-table";
import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InternalFooter from "../../components/InternalFooter/InternalFooter";

const EditProfilePage = () => {
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
  });
  const [title, setTitle] = useState("Edit Profile");
  const [countries, setCountries] = useState([]);
  const [selectedMobileCode, setSelectedMobileCode] = useState("");
  const [type, setType] = useState("");
  
  useEffect(() => {
    let user = null;

    try {
      user = JSON.parse(localStorage.getItem("user"));
      setType(user?.type);
    } catch {}
    if (!user) return;
    setTitle(
      user?.type === "corporate"
        ? "Edit Corporate Profile"
        : type === "user"
        ? "Edit Corporate User Profile"
        : "Edit Profile"
    );
   
    const fetchProfile = async () => {
      try {
        let res;
        if (user?.type === "corporate") {
          res = await axiosInstance.get(`/auth/corporate/details/${user.corporateId}`);
          const data = res.data;
          console.log(data);
          setInitialValues({
            id:user.corporateId|| "",
            name: data.name || "",
            email: data.email || "",
            phone: data.phone || "",
            country: data.country || "",
          });
        } else if (user?.type === "user") {
          res = await axiosInstance.get(`/auth/details/${user.id}`);
          const data = res.data;
          setInitialValues({
            id:user.id,
            name: data.full_name || "",
            email: data.User.email || "",
            phone: data.phone || "",
            employeenumber:data.employee_id||"",
            roleid:data.role_id
          });
        }
      } catch (err) {
        toast.error(
          err?.response?.data?.message || "Failed to fetch profile details"
        );
      }
    };
    fetchProfile();
  }, []);
  useEffect(() => {
    const fetchCountries = async () => {

      try {
        const res = await axiosInstance.get(`/auth/countrylist`);

        const data = res.data;
        setCountries(data);
      } catch (err) {
        console.error("Failed to fetch countries:", err);
      }
    };

    fetchCountries();
  }, []);
  const handleSubmit = async (values, actions) => {
  console.log("entered");

  try {
    let endpoint = '';
    let payload = {};
    if (type === 'user') {
      endpoint = '/auth/corporateuser/profileupdate';
      payload = {
        id: values.id,
        full_name: values.name,
        employee_id: values.employeenumber,
        phone: values.phone
      };
    } else {
      endpoint = '/auth/corporate/profileupdate';
      payload = values; // or pick specific corporate fields if needed
    }

    const response = await axiosInstance.post(endpoint, payload);
    console.log('Response:', response.data);

    toast.success("Profile updated successfully!", {
      position: "top-right",
      autoClose: 2000,
    });

    actions.setSubmitting(false);

    setTimeout(() => {
      navigate('/task/tasklist');
    }, 2200);

  } catch (error) {
    console.error('Error submitting form:', error);

    toast.error("Error updating profile. Please try again.", {
      position: "top-right",
      autoClose: 3000,
    });

    actions.setSubmitting(false);
  }
};

  return (
    <div className="row" >
      <div className="col-xl-12 col-xxl-12">
         <ToastContainer />
        <EditProfileForm
          initialValues={initialValues}
          title={title}
          onSubmit={handleSubmit}
          countries={countries}
          type={type}
        />
      </div>
      <InternalFooter />
    </div>
  );
};

export default EditProfilePage; 